export default __webpack_public_path__ + "static/media/indicator-medium.57f3848c.png";